/* eslint-disable prettier/prettier */

import { createSlice } from '@reduxjs/toolkit'

const bookingsReducer = createSlice({
    name: 'bookingsReducer',
    initialState: {
        upcomming: {},
        past: {},
        cancelled: {},
        AllBookings: {},
        roomTypes: [],
        stayTypes: [],
        rooms: [],
        currentPage:'',
        loading: false,
        bookingCounts: {
            upcomming: 0,
            past: 0,
            cancelled: 0,
            total: 0
        },
        searchText:{
            name: '',
            startDate: '',
            endDate: '',
            roomType: [],
            room: [],
            StayType: [],
            resNo: ''
        },
        searchModal: true
    },
    reducers: {
        setField(state, action) {
            
            state[action.payload.name] = action.payload.value
        },
        setUpcomming(state, action) {
            state.upcomming = action.payload
        },
        setSearchText(state, action) {
            state.searchText[action.payload.name] = action.payload.value
        },
        setSelectedStayType(state, action) {
            state.StayType = action.payload
        },
        setBookingCounts(state, action) {
            state.bookingCounts = action.payload
        },
        clearSearchForm(state, action) {
            state.searchText = {
                name: '',
                startDate: '',
                endDate: '',
                roomType: [],
                room: [],
                StayType: [],
                resNo: ''
            }

        }

    },
});

export const {
    setUpcomming,
    setField,
    setSearchText,
    setSelectedStayType,
    clearSearchForm,
    setBookingCounts
} = bookingsReducer.actions;
export default bookingsReducer.reducer;